import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import H2Font from "Root/profile/components/common/H2Font";
import LargeFont from "Root/profile/components/common/LargeFont";
import RoundedGainfulButton from "Root/profile/components/common/RoundedGainfulButton";
import Image from "./images/target_promo.png";
import styles from "./styles.module.scss";
const TargetPromo = () => {
    const goToTarget = () => {
        window.open("https://www.target.com/b/gainful/-/N-q643lec1mos");
    };
    return (_jsx("div", { className: styles.promo, children: _jsxs("div", { className: styles.wrapper, children: [_jsxs("div", { className: styles.text, children: [_jsx(H2Font, { children: "Looking for more?" }), _jsx(LargeFont, { children: "Explore the full Gainful system of performance nutrition including personalized Protein, Pre-Workout, and\u00A0 Hydration at a store near you." }), _jsx(RoundedGainfulButton, { label: "Shop at target", onClick: goToTarget })] }), _jsx("div", { className: styles.img, children: _jsx("img", { src: Image, alt: "promo" }) })] }) }));
};
export default TargetPromo;
